import MudProperties from './MudProperties';

export default MudProperties;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/FluidData/MudProperties/index.tsx